var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { createElement } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ComponentsManager } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core';
export var Viewport = function Viewport(_a) {
  var _b = _a.routes,
      routes = _b === void 0 ? [] : _b,
      match = _a.match,
      entity = _a.entity,
      entities = _a.entities,
      className = _a.className,
      style = _a.style;
  var isLogined = services.privilege.hasPrivilege();
  return React.createElement(Switch, null, routes.map(function (route, index) {
    var path = route.path,
        component = route.component,
        childRoutes = route.childRoutes,
        privilege = route.privilege,
        authentication = route.authentication,
        exact = route.exact;

    if (privilege && !services.privilege.check(privilege.path, privilege.level)) {
      // 禁止访问无权限视图
      return null;
    }

    if (authentication === false && isLogined) {
      // 授权视图在用户已登录后禁止访问
      return null;
    }

    if (authentication && !isLogined) {
      // 用户未登录时跳转授权视图
      return React.createElement(Redirect, {
        key: "route-" + index,
        to: authentication
      });
    }

    if (match && match.url !== '/') {
      path = match.url + path;
    }

    return React.createElement(Route, {
      path: path,
      key: "route-" + index,
      exact: exact,
      render: function render(props) {
        return createElement(ComponentsManager.get(component), __assign(__assign({}, props), {
          entity: entity,
          routes: childRoutes,
          params: props.match.params,
          entities: entities,
          className: className,
          style: style
        }));
      }
    });
  }), routes.reduce(function (result, _a, index) {
    var path = _a.path,
        privilege = _a.privilege,
        isIndex = _a.isIndex;

    if (isIndex && (!privilege || services.privilege.check(privilege.path, privilege.level))) {
      result.push(React.createElement(Redirect, {
        key: "redirect-" + index,
        to: path
      }));
    }

    return result;
  }, []));
};